import { createColumnHelper } from '@tanstack/react-table'

export const columnHelper = createColumnHelper<APIPaymentMethod>()

const BRANDS = ['visa', 'american_express', 'mastercard']

// Need these so re-renders don't try to get the images again
const Visa = props => (
  <img src={`/imgs/billing/${BRANDS[0]}.png`} alt='' {...props} />
)
const AmericanExpress = props => (
  <img src={`/imgs/billing/${BRANDS[1]}.png`} alt='' {...props} />
)
const MasterCard = props => (
  <img src={`/imgs/billing/${BRANDS[2]}.png`} alt='' {...props} />
)
const Other = props => (
  <img src='/imgs/billing/credit_card.png' alt='' {...props} />
)

const CARDS = {
  [BRANDS[0]]: Visa,
  [BRANDS[1]]: AmericanExpress,
  [BRANDS[2]]: MasterCard
}

export const getIcon = (method: APIPaymentMethod) => {
  const defaultIcon = props => <div {...props} />

  const { type, brand } = method

  if (type === 'card') {
    if (!Object.keys(CARDS).includes(brand)) {
      return Other
    }

    return CARDS[brand]
  }

  return defaultIcon
}
